/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the BountyExtensionWindowDto interface.
 */
export function instanceOfBountyExtensionWindowDto(value) {
    let isInstance = true;
    return isInstance;
}
export function BountyExtensionWindowDtoFromJSON(json) {
    return BountyExtensionWindowDtoFromJSONTyped(json, false);
}
export function BountyExtensionWindowDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currentExpiresAt': !exists(json, 'currentExpiresAt') ? undefined : (new Date(json['currentExpiresAt'])),
        'latestExpiresAt': !exists(json, 'latestExpiresAt') ? undefined : (new Date(json['latestExpiresAt'])),
        'canExtend': !exists(json, 'canExtend') ? undefined : json['canExtend'],
        'blockedReason': !exists(json, 'blockedReason') ? undefined : json['blockedReason'],
    };
}
export function BountyExtensionWindowDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currentExpiresAt': value.currentExpiresAt === undefined ? undefined : (value.currentExpiresAt.toISOString()),
        'latestExpiresAt': value.latestExpiresAt === undefined ? undefined : (value.latestExpiresAt.toISOString()),
        'canExtend': value.canExtend,
        'blockedReason': value.blockedReason,
    };
}
